import { api } from '@/modules/shared/lib/axios'

type DeletePdfPayload = {
  orderId: string
  usuarioId: number
}

export async function deletePdfService(payload: DeletePdfPayload) {
  const data = await api.delete(
    `pdf/id/${payload.usuarioId}/${payload.orderId}`,
  )

  return data
}
